// extracted by mini-css-extract-plugin
export default {"container":"videos__container__BhHIg"};